import React, { Fragment } from 'react';
import DOMPurify from 'dompurify';
import renderHTML from 'react-render-html';
import { socialLinkIds } from '../../analyticsTags';

const LinkFa = ({ url, icon_class: iconCss, title, name }) => {
  return (
    <a
      href={url}
      id={socialLinkIds.computed.socialLink(title)}
      className={name}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Wheel of Fortune on ${title}`}>
      <i className={iconCss} aria-hidden="true"/>
    </a>
  );
};

const LinkSvg = ({ url, svg_code: svg, title, name }) => {
  return (
    <a
      href={url}
      id={socialLinkIds.computed.socialLink(title)}
      className={name}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Wheel of Fortune on ${title}`}>
      {renderHTML(DOMPurify.sanitize(svg))}
    </a>
  );
};

export const SocialLinks = ({ inFooter = false, links = {} }) => (
  <ul className={`navbar-nav${inFooter ? ' ml-md-auto' : ' '} social-links`}>
    {Object.keys(links).map((k, i) => {
      const link = links[`${k}`];
      return (
        <Fragment key={`nav_item_${i}`}>
          <li className="nav-item social_icon">
            {link.icon_type === 'font_awesome' ? (
              <LinkFa {...link} name={k} />
            ) : (
              <LinkSvg {...link} name={k} />
            )}
          </li>
          {inFooter && <span>&nbsp;</span>}
        </Fragment>
      );
    })}
  </ul>
);

export default SocialLinks;
